import { render, staticRenderFns } from "./vTemplateBuilder.vue?vue&type=template&id=2f7f68b9&scoped=true"
import script from "./vTemplateBuilder.vue?vue&type=script&lang=js"
export * from "./vTemplateBuilder.vue?vue&type=script&lang=js"
import style0 from "./vTemplateBuilder.vue?vue&type=style&index=0&id=2f7f68b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7f68b9",
  null
  
)

export default component.exports